export default __webpack_public_path__ + "static/header2b-mobile-465d0d9ba04e493be293de064af4aa37.png";